import React from 'react';
import PropTypes from 'prop-types';
import {Wrapper} from '../../Wrapper';
import {Image} from '@learningblocks/storybook-components';
import CloseLid from '@learningblocks/exp-constants/lib/Images/mc_lid_open.svg';
import OpenLid from '@learningblocks/exp-constants/lib/Images/mc_lid_close.svg';
import RemoveRotor from '@learningblocks/exp-constants/lib/Images/mc_remove_rotor_icon.svg';
import RemoveTube from '@learningblocks/exp-constants/lib/Images/mc_remove_tube_icon.svg';
import Settings from '@learningblocks/exp-constants/lib/Images/mc_settings_icon.svg';
import Glossary from '@learningblocks/exp-constants/lib/Images/mc_glossary.svg';
import {MCStateContext} from '../..';
import {TABS} from '../../ModalWindow/ModalWindow.utils';

import './style.scss';
/**
 * TooltipHover:
 *    to render tooltip when centrifuge state is hover
 */
export function TooltipHover(props) {
  const {isLidOpen} = React.useContext(MCStateContext);

  const className =
    isLidOpen && (props.solutionPresent || props.rotorPresent)
      ? `mc_tooltip_hover--evenItems`
      : `mc_tooltip_hover--oddItems`;

  const renderOpenLid = () =>
    !isLidOpen && (
        <Image
          src={OpenLid}
          alt='open lid'
          onClick={props.toggleLid}
          className='ps_tooltip_hover_icon'
        />
    );
  const renderCloseLid = () =>
    isLidOpen && (
        <Image
          src={CloseLid}
          alt='close lid'
          onClick={props.toggleLid}
          className='ps_tooltip_hover_icon'
        />
    );

  const renderSettings = () => {
    const onClick = () => {
      props.setModalView(TABS.TOP_VIEW);
      props.openModal();
    };
    return (
        <Image
          src={Settings}
          alt='open settings'
          className='ps_tooltip_hover_icon'
          onClick={onClick}
        />
    );
  };

  const renderRemoveSolution = () => {
    const onClick = () => {
      props.removeSlotItems('solution');
    };
    return (
      isLidOpen &&
      props.solutionPresent && (
          <Image
            src={RemoveTube}
            alt='remove solution tubes'
            className='ps_tooltip_hover_icon'
            onClick={onClick}
          />
      )
    );
  };

  const renderRemoveRotor = () => {
    const onClick = () => {
      props.removeSlotItems('rotor');
    };
    return (
      isLidOpen &&
      !props.solutionPresent &&
      props.rotorPresent && (
          <Image
            src={RemoveRotor}
            alt='remove solution rotor'
            onClick={onClick}
          />
      )
    );
  };

  const renderGlossary = () => {
    return <Image src={Glossary} alt='open glossary' />;
  };

  const onMouseLeave = () => props.setHover(false);
  const onMouseEnter = () => props.setHover(true);

  return (
    <Wrapper
      className={`${className} ${props.className}`}
      onMouseLeave={onMouseLeave}
      onMouseEnter={onMouseEnter}>
      {/* {renderGlossary()} */}
      {renderOpenLid()}
      {renderCloseLid()}
      {renderRemoveSolution()}
      {renderRemoveRotor()}
      {renderSettings()}
    </Wrapper>
  );
}

TooltipHover.propTypes = {
  /**
   * className
   */
  className: PropTypes.string,
  /**
   * callback function to set hover state
   */
  setHover: PropTypes.func,
  /**
   * specifies if there are solution(tubes) in centrifuge
   */
  solutionPresent: PropTypes.bool,
  /**
   * specifies if there are rotors in centrifuge
   */
  rotorPresent: PropTypes.bool,
  /**
   * callback function to toggle microcentrifuge lid open and close
   */
  toggleLid: PropTypes.func,
  /**
   * callback function to set modal view tab (accepts values FRONT_VIEW or TOP_VIEW)
   */
  setModalView: PropTypes.func,
  /**
   * callback function to open modal window
   */
  openModal: PropTypes.func,
  /**
   * callback function to remove all items from slot' item can be solution(tube) or rotor
   */
  removeSlotItems: PropTypes.func,
};
